module.exports = __webpack_public_path__ + "assets/emblem_onetable.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/emblem_onetable.png
 ** module id = 215
 ** module chunks = 1
 **/